import React, { useState } from "react";
import logo from '../image/localreal_logo_trans_resize.png';

//const backendsourse = "http://127.0.0.1:8080";
const backendsourse = "https://localreal-backend-91398629203.us-west2.run.app"
const AboutPage = () => {
  const [feedback, setFeedback] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!feedback.trim()) return;
    
    const res = await fetch(backendsourse + "/api/feedback", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ feedback }),
    });

    if (res.ok) {
      setMessage("✅ Thank you for your feedback!");
      setFeedback("");
    } else {
      setMessage("❌ Error sending feedback.");
    }
  };

  return (
    <div className="p-6">
      <img src={logo} alt="LocalReal" style={{height: '90px', width: 'auto',marginBottom: '20px',marginTop: '-10px'}} />
      <div className="bg-gray-50 rounded-2xl shadow-md p-6 max-w-3xl ">
        <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 items-center gap-2 mb-6">
            <span>Know Your Real Market.</span>
        </h1>

        <p className="text-gray-700 leading-relaxed mb-5">
            LocalReal is your smart companion for discovering real estate trends in your neighborhood.
            Instantly access up-to-date home prices, sales insights, and rental or mortgage estimates—tailored to your location.
            Whether you're buying, selling, investing, or just curious, LocalReal makes complex market data simple, visual, and local.
        </p>

        <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded mb-4">
            <p className="text-blue-800 font-medium">
            🔍 Currently, LocalReal supports metro areas in <strong>California</strong> only.
            </p>
            <p className="text-blue-700">
            If you're outside California and would like to use LocalReal in your region, please ask your local real estate agent to get in touch — I'm open to collaborating and expanding coverage!
            </p>
        </div>

        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded mb-4">
            <p className="text-yellow-800 font-medium">
            📅 Note:
            </p>
            <p className="text-yellow-700">
            Price data reflects transactions from the past <strong>60 days</strong> only, ensuring you're seeing the most recent trends.
            </p>
        </div>

        <div className="bg-green-50 border-l-4 border-green-400 p-4 rounded mb-4">
            <p className="text-green-800 font-medium">
            🤝 Interested in partnering with me?
            </p>
            <p className="text-green-700">
            If you're a business looking to advertise, or if you'd like to bring LocalReal to your city or state, shoot me a mail. Let’s grow together! 
            </p>
        </div>
        <div className="bg-purple-50 border-l-4 border-purple-400 p-4 rounded mb-4">
            <p className="text-purple-800 font-medium">
            🏠 Want to buy or sell real property?
            </p>
            <p className="text-purple-700">
            Shoot me a mail or leave your contact info in the feedback. I am willing to help to get your dream home! 
            </p>
        </div>

        <div className="bg-pink-50 border-l-4 border-pink-300 p-4 rounded mb-4">
            <p className="text-pink-800 font-medium">❤️ Like what you're seeing?</p>
            <p className="text-pink-700">
            This app is independently built and maintained. If it’s helpful to you, please consider making a small donation to support ongoing updates, hosting, and expansion. Every bit helps — thank you!
            </p>
        </div>
      

      <h3 className="text-xl font-semibold mt-6 mb-2">💬 Leave Your Feedback</h3>
      <form onSubmit={handleSubmit}>
        <textarea
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          rows="4"
          placeholder="Your comment or suggestion..."
          className="w-full p-3 border rounded mb-2"
        />
        
          {/* <input
            type="checkbox"
            id="newsletter"
            className="mr-2"
          /> */}
          
          <div className="flex mb-4 gap-3"> 
            <button type="submit" className="mb-4 bg-blue-500 hover:bg-blue-700 text-white font-semibold px-4 py-2 rounded">Submit</button>
            <a
            href="https://www.buymeacoffee.com/localreal"
            target="_blank"
            rel="noopener noreferrer"
            className="mb-4 w-[200px] px-4 py-2 bg-[#185a8b] text-white text-sm font-semibold rounded-md hover:bg-[#426E8F] transition duration-200 shadow-sm rounded items-center flex justify-center"
          >
            🙏 Buy Me A Coffee ☕
          </a>
          </div>
      </form>
      {message && <p className="mt-2">{message}</p>}
      </div>
    </div>
  );
};

export default AboutPage;
